export default __webpack_public_path__ + "static/media/pattern_orange.1af4a2cb.png";